import { DITypes, LocalStorageKeys } from "@/core/@types/types";
import { diContainer } from "@/di";
import { IHttpMiddlewareIntercept } from "../protocols/types";
import useStorage from "@/core/plugins/useStorage";

const handleExpiredCheckpoint = (lastSave: string): boolean => {
  const dataAtual = new Date();
  const ultimoCheckpoint = new Date(lastSave);

  const minutosDataAtual = dataAtual.getMinutes();
  const minutosUltimoCheckpoint = ultimoCheckpoint.getMinutes();

  const minutos = minutosDataAtual - minutosUltimoCheckpoint;

  const tempoParaValidar = 1;

  const isRevalidarToken = minutos < 0 || minutos > tempoParaValidar;

  return isRevalidarToken;
};

const saveCurrentDate = () =>
  useStorage().set(LocalStorageKeys.LastChanged, new Date().toString());

export const httpInterceptor = () => {
  //é necessário os arguemntos para o decorator, mesmo não usando
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  return (
    // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
    target: any,
    // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
    memberName: string,
    // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
    propertyDescriptor: PropertyDescriptor
  ) => {
    if (import.meta.env.DEV) return;

    const lastSave = useStorage().get(LocalStorageKeys.LastChanged); // Acho que aqui deve ser uma entidade que vai lidar com a lógica da ultima vez que foi salvo

    const naoPossuiCheckpoint = !lastSave || lastSave === "";

    if (naoPossuiCheckpoint) {
      saveCurrentDate();
    } else {
      const tokenExpirou = handleExpiredCheckpoint(lastSave);

      if (!tokenExpirou) return;

      saveCurrentDate();
    }

    const intercept = diContainer.get<IHttpMiddlewareIntercept>(
      DITypes.HTTP_MIDDLEWARE_INTERCERPT
    );

    intercept.sendFinancasToken();
  };
};
